// extracted by mini-css-extract-plugin
export default {"spanBold":"Domains_spanBold__Hzy5S","addButton":"Domains_addButton__3bu-N"};